// extracted by mini-css-extract-plugin
export default {"stationsMenu":"StationsMenu_stationsMenu__hXtRS","menuItemText":"StationsMenu_menuItemText__cRxpR"};